var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "structure-panel" },
    [
      _c("MolstarStructureViewer", {
        ref: "viewer",
        attrs: {
          scene: _vm.scene,
          sceneInput: _vm.sceneInput,
          toolbar: _vm.toolbar,
          bgColorLight: _vm.bgColorLight,
          bgColorDark: _vm.bgColorDark,
        },
        on: {
          makeImage: _vm.handleMakeImage,
          makeCIF: _vm.handleMakeCIF,
          sceneEvent: _vm.handleSceneEvent,
        },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _c("StructureHoverTooltip", {
                  attrs: { value: _vm.hoverInfo },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }